import type {FacebookLikePostTriggerStruct} from '@cohort/shared/apps/facebook/triggers/likePost';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaWithRefresh from '@cohort/wallet/components/challenges/OpenCtaWithRefresh';
import {useTranslation} from 'react-i18next';

const FacebookLikePostTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<FacebookLikePostTriggerStruct>
> = ({config, stepId, processStepVerification, trackingMetadata}) => {
  const {t} = useTranslation('app-facebook', {
    keyPrefix: 'triggerIntegrations.like-post',
  });

  return (
    <OpenCtaWithRefresh
      url={config.postPermalink}
      stepId={stepId}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
      ctaTitle={t('ctaTitle')}
      refreshCtaTitle={t('refreshTitle')}
    />
  );
};

export default FacebookLikePostTriggerActionCtaComponent;
